import i18next from "i18next"
import * as Yup from "yup"
import React from "react"
import { useTranslation } from "react-i18next"

const slugReg = new RegExp("^[A-Za-z\u0621-\u064A-]*$")
const passwordReg = new RegExp(
  "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
)



export default function useCustomValidation() {

  const { t } = useTranslation()

  const strongPasswordMsg = t("validation.strongPass")

  const loginSchema = Yup.object({
    email: Yup.string().required(t("validation.email")).nullable(),
    password: Yup.string().required(t("validation.password")).nullable(),
  })

  const addAdminSchema = Yup.object({
    name: Yup.string().required(t("validation.name")),
    email: Yup.string().required(t("validation.email")),
    language: Yup.string(),

    password: Yup.string()
      .required(t("validation.password"))
      .matches(passwordReg, strongPasswordMsg),
    confirmPassword: Yup.string()
      .required(t("validation.confirmPass"))
      .oneOf([Yup.ref("password"), null], t("validation.confirmPass")),
    // amenities: Yup.array()
    //   .of(
    //     Yup.object().shape({
    //       value: Yup.number(),
    //       label: Yup.string(),
    //     })
    //   )
    //   .nullable(),
    roleId: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable()
      .required(t("validation.roleId")),
  })

  const editAdminSchema = Yup.object({
    username: Yup.string().required(t("validation.username")),
    email: Yup.string().required(t("validation.email")),
    language: Yup.string(),
    amenities: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.number(),
          label: Yup.string(),
        })
      )
      .nullable(),
    roleId: Yup.object()
      .shape({
        value: Yup.number(),
        label: Yup.string(),
      })
      .nullable()
      .required(t("validation.role")),
  })

  const editProfileSchema = Yup.object({
    username: Yup.string().required(t("validation.username")),
    email: Yup.string().required(t("validation.email")),
    password: Yup.string().nullable(),
    img: Yup.string().nullable(),
  })


  const roleSchema = Yup.object({
    name: Yup.string().required(t("validation.name")),
    permissions: Yup.array()
      .of(Yup.number())
      .required(t("validation.permissions"))
      .min(1, t("validation.permissions")),
    types: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.string(),
          label: Yup.string(),
        })
      )
      .nullable(),
  })

  const addLeadSourceSchema = Yup.object({
    name: Yup.string().required(t("validation.name")),
  });
  const addBusinessCategorySchema = Yup.object({
    name: Yup.string().required("Name is required"),
  });

  const addLeadContactSchema = Yup.object({
    type: Yup.string().required("Type is required"),
    notes: Yup.string().max(500, "Notes can be at most 500 characters"),
    potentialBudget: Yup.number()
      .typeError("Potential Budget must be a number")
      .positive("Potential Budget must be positive")
      .nullable(),
    statusLeadContactId: Yup.object()
      .nullable()
      .required("Status is required"),
    leadId: Yup.object()
      .nullable()
      .required(" lead is required"),
  });


  const editLeadContactSchema = Yup.object({
    name: Yup.string()
      .required("Name is required")
      .min(2, "Name should be at least 2 characters"),

    email: Yup.string()
      .required("Email is required")
      .email("Invalid email address"),

    phone: Yup.string()
      .required("Phone number is required")
      .matches(/^[0-9+\-\s()]*$/, "Invalid phone number"),

    position: Yup.string()
      .required("Position is required")
      .min(2, "Position should be at least 2 characters"),

    lead: Yup.object()
      .nullable()
      .shape({
        value: Yup.string().required("Lead is required"),
        label: Yup.string().required(),
      })
      .required("Lead is required"),

    assignedTo: Yup.object()
      .nullable()
      .shape({
        value: Yup.string().required("Assigned To is required"),
        label: Yup.string().required(),
      })
      .required("Assigned To is required"),
  });

  const addStatusDealSchema = Yup.object({
    name: Yup.string().required("Name is required"),
  });

  const addServiceSchema = Yup.object({
    names: Yup.array()
      .of(Yup.string().required("Name is required"))
      .min(1, "At least one name is required"),
  });

  const addLogSchema = Yup.object({
    delivered: Yup.boolean().required(t("Required")),
    pending: Yup.boolean().required(t("Required")),
    notes: Yup.string().max(500, t("Max 500 characters")),
    files: Yup.array().of(
      Yup.string().url(t("Must be a valid URL"))
    ),
    dealId: Yup.object()
      .nullable()
      .required("dealId is required"),
  });


  const deliverableSchema = Yup.object({
    timeline: Yup.date().required("Timeline is required"),
    deliverable: Yup.string().required(t("Deliverable is required")),
    notes: Yup.string(),
  });


  const feedbackSchema = Yup.object({
    clientSatisfaction: Yup.string().required(t("Required")),
    notes: Yup.string(),
    campaignDelivered: Yup.boolean(),
    upsellPotential: Yup.boolean(),
  });


  const dealSchema = Yup.object({
    budget: Yup.number().required("Budget is required"),
    StatusDeal: Yup.string().required("Status is required"),
    deliverables: Yup.array().of(Yup.string()),
    services: Yup.array().of(Yup.string()),
    leadId: Yup.string().required("Lead is required"),
  });

  const addStatusLeadContactSchema = Yup.object({
    name: Yup.string().required(t("validation.name")),
    level: Yup.mixed()
      .nullable()
      .oneOf(['start', 'failed', 'final', null], t("Invalid level selected"))
  });
  const addLeadSchema = Yup.object({
    name: Yup.string().required(t("validation.name")),
    email: Yup.string().email(t("validation.invalidEmail")).required(t("validation.email")),
    phone: Yup.string()
      .required(t("validation.phone"))
      .matches(/^[0-9+\-\s()]*$/, t("validation.invalidPhone")),
    whatsApp: Yup.string()
      .required(t("validation.whatsApp"))
      .matches(/^[0-9+\-\s()]*$/, t("validation.invalidPhone")),

    leadSource: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .nullable()
      .required(t("validation.leadSource")),

    assignedTo: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .nullable()
      .required(t("validation.assignedTo")),

    businessCategory: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .nullable()
      .required(t("validation.businessCategory")),
  });

  return {
    loginSchema,
    addAdminSchema,
    editAdminSchema,
    editProfileSchema,
    roleSchema,
    addLeadSourceSchema,
    addBusinessCategorySchema,
    addLeadContactSchema,
    editLeadContactSchema,
    addStatusDealSchema,
    addServiceSchema,
    addLogSchema,
    deliverableSchema,
    feedbackSchema,
    dealSchema,
    addStatusLeadContactSchema,
    addLeadSchema,
  }

}

